"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.faq = exports.why_work_with_us = exports.info = exports.about_us = exports.priority_phone_numbers = exports.regions = exports.legal = exports.how_we_calculate_percentage_off = exports.giftcard_terms_and_conditions = void 0;
exports.giftcard_terms_and_conditions = "/legal/giftcard-terms-and-conditions";
exports.how_we_calculate_percentage_off = "/legal/how-we-calculate-percentage-off";
exports.legal = "/legal";
exports.regions = "/regions{?brand,no_detect}";
exports.priority_phone_numbers = "/priority-phone-numbers{?brand,no_detect}";
exports.about_us = "/info/about-us";
exports.info = "/info";
exports.why_work_with_us = "/info/why-work-with-us";
exports.faq = "/faq";
